"use client";
import { Box, Button, Stack, styled, Typography } from "@mui/material";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { TitleGradientText } from "../title_gradient_text";
import { homeAllTimeFavorites } from "@/data/recommended_menus_mock_data";
import { useRouter } from "next/navigation";

const GridImageContainer = styled(Box)`
  display: grid;
  grid-template-areas:
    "top-left top-left top-right"
    "bottom-left bottom-right bottom-right";

  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 310px);
  width: 100%;
  @media (max-width: 900px) {
    grid-template-areas:
      "top-left"
      "top-right"
      "bottom-left"
      "bottom-right";
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 180px);
  }
`;

export function MenuSection() {
  const highlightMenu = homeAllTimeFavorites.slice(0, 4);
  const router = useRouter();

  console.log(homeAllTimeFavorites.forEach((item) => console.log(item.imageCover)));
  const handleRecommendedMenusClick = () => {
    router.push("/recommended-menus");
  };

  return (
    <Stack
      width="100%"
      sx={{
        backgroundImage: {
          xs: `url(/images/home/menu_bg_mobile.png)`,
          md: `url(/images/home/menu_bg.png)`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      justifyContent="center"
      alignItems="center"
      px={{
        xs: 4,
        md: 30,
      }}
      py={{
        xs: 15,
        md: 25,
      }}
      gap={{
        xs: 12,
        md: 15,
      }}
    >
      <Stack gap={2}>
              <TitleGradientText variant="h3" textAlign="center">
                เมนูไหนก็แซ่บ
              </TitleGradientText>
              <TitleGradientText variant="body1" textAlign="center">
                ด้วยเคล็ดลับสูตรเด็ดเชฟไพรฑูรย์
              </TitleGradientText>
            </Stack>

      <GridImageContainer gap={5}>
        {highlightMenu.map((item, index) => {
          const gridArea = [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ];
          return (
            <Stack
              key={index}
              width="100%"
              height="100%"
              borderRadius={4}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              p={{ xs: 4, md: 6 }}
              sx={{
                backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 50%), url(${item.imageCover})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                gridArea: gridArea[index],
                cursor: "pointer",
              }}
              boxShadow="0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.15);"
            >
              <Stack direction="row" gap={2}>
                <Typography variant="body2">{item.name}</Typography>
                <Image src="svg/fire.svg" width={20} height={20} alt="" />
              </Stack>
              <Stack
                width={24}
                height={24}
                bgcolor="#17232B"
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                sx={{
                  transform: "rotate(45deg)",
                  cursor: "pointer",
                }}
              >
                <Image src="/svg/arrow.svg" width="10" height="10" alt="" />
              </Stack>
            </Stack>
          );
        })}
      </GridImageContainer>

      <Stack>
        <Button variant="contained" onClick={handleRecommendedMenusClick}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              เมนูแนะนำทั้งหมด
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
